import { render, staticRenderFns } from "./MediaItensCestaChart.vue?vue&type=template&id=0b04be0b"
import script from "./MediaItensCestaChart.vue?vue&type=script&lang=js"
export * from "./MediaItensCestaChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports